/**
 * Logged-in shopper who may use the cart drawer: retail customer, or admin in
 * customer view (isClientView / תצוגת לקוח). Guests are excluded.
 */
export const canUseCartDrawer = (user, role, isClientView = false) => {
  if (!user) return false;
  if (role && !isClientView) return false;
  try {
    return !localStorage.getItem("userRole")?.includes("guest");
  } catch {
    return false;
  }
};

/** @deprecated Prefer canUseCartDrawer — name kept for older imports. */
export const isRetailCustomerLoggedIn = canUseCartDrawer;

/** Routes where the side cart drawer is available (home + product browsing). */
export const isCartDrawerRoute = (pathname = "") => {
  if (!pathname) return false;
  if (pathname === "/") return true;
  return (
    pathname.includes("/category/") ||
    pathname.includes("/search") ||
    pathname.includes("/sales")
  );
};
